import axios from "axios";
import { constructSearchObj } from "../../utils/utils";
import {
  PLATFORM_ASSIGN_UNASSIGN_MENU_ITEMS_TO_RESTAURANTS,
  PLATFORM_CLEAR_MENU_ITEMS,
  PLATFORM_CLEAR_MENU_ITEMS_CATALOG,
  PLATFORM_CLEAR_PLATFORMS,
  PLATFORM_CLEAR_PRODUCT_GROUPS,
  PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG,
  PLATFORM_FETCH_MENU_ITEM,
  PLATFORM_FETCH_MENU_ITEMS,
  PLATFORM_FETCH_MENU_ITEMS_CATALOG,
  PLATFORM_FETCH_MENU_ITEMS_FILTERED,
  PLATFORM_FETCH_PLATFORMS,
  PLATFORM_FETCH_PRODUCT_GROUPS,
  PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED,
  PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE
} from "../action-types/platforms-types";
import { axiosAction } from "../../utils/axiosAction";

const ENDPOINT_PRODUCT_CATEGORIES = `${process.env.REACT_APP_ENDPOINT_PRODUCT_CATEGORIES}`;
const ENDPOINT_MENU_ITEMS = `${process.env.REACT_APP_ENDPOINT_MENU_ITEMS}`;

const getPlatformsRequest = () => ({
  type: PLATFORM_FETCH_PLATFORMS.REQUEST,
});
const getPlatformsSuccess = payload => ({
  type: PLATFORM_FETCH_PLATFORMS.SUCCESS,
  payload,
});
const getPlatformsRejected = () => ({
  type: PLATFORM_FETCH_PLATFORMS.REJECTED,
});

const getGroupsRequest = () => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS.REQUEST,
});
const getGroupsSuccess = payload => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS.SUCCESS,
  payload,
});
const getGroupsRejected = () => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS.REJECTED,
});
const getMenuItemRequest = () => ({
  type: PLATFORM_FETCH_MENU_ITEM.REQUEST,
});
const getMenuItemSuccess = payload => ({
  type: PLATFORM_FETCH_MENU_ITEM.SUCCESS,
  payload,
});
const getMenuItemRejected = () => ({
  type: PLATFORM_FETCH_MENU_ITEM.REJECTED,
});

const getMenuItemsRequest = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS.REQUEST,
});
const getMenuItemsSuccess = payload => ({
  type: PLATFORM_FETCH_MENU_ITEMS.SUCCESS,
  payload,
});
const getMenuItemsRejected = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS.REJECTED,
});

const getMenuItemsCatalogRequest = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_CATALOG.REQUEST,
});
const getMenuItemsCatalogSuccess = payload => ({
  type: PLATFORM_FETCH_MENU_ITEMS_CATALOG.SUCCESS,
  payload,
});
const getMenuItemsCatalogRejected = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_CATALOG.REJECTED,
});

const getMenuItemsFilteredRequest = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_FILTERED.REQUEST,
});
const getMenuItemsFilteredSuccess = payload => ({
  type: PLATFORM_FETCH_MENU_ITEMS_FILTERED.SUCCESS,
  payload,
});
const getMenuItemsFilteredRejected = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_FILTERED.REJECTED,
});
const getGroupsFilteredRequest = () => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED.REQUEST,
});
const getGroupsFilteredSuccess = payload => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED.SUCCESS,
  payload,
});
const getGroupsFilteredRejected = () => ({
  type: PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED.REJECTED,
});

export const clearProductGroups = () => ({
  type: PLATFORM_CLEAR_PRODUCT_GROUPS,
});

export const clearProductGroupsCatalog = () => ({
  type: PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG,
});

export const clearMenuItemsCatalog = () => ({
  type: PLATFORM_CLEAR_MENU_ITEMS_CATALOG,
});

export const clearMenuItems = () => ({
  type: PLATFORM_CLEAR_MENU_ITEMS,
});

export const clearPlatforms = () => ({
  type: PLATFORM_CLEAR_PLATFORMS,
});

const getMenuItemsToValidateRequest = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.REQUEST,
});
const getMenuItemsToValidateSuccess = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.SUCCESS,
});
const getMenuItemsToValidateRejected = () => ({
  type: PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE.REJECTED,
});

export const getCategories =
  (searchObj, redux = true): any =>
    async dispatch => {
      if (redux) {
        dispatch(getPlatformsRequest());
      }
      try {
        const result: any = await axios(
          `${ENDPOINT_PRODUCT_CATEGORIES}${constructSearchObj(searchObj)}`,
        );
        if (redux) {
          dispatch(
            getPlatformsSuccess({
              data: result.data,
            }),
          );
        }
        return result;
      } catch (error) {
        if (redux) {
          dispatch(getPlatformsRejected());
        }
        return error.response;
      }
    };
export const getGroups =
  (searchObj, idCategory = 0, redux = true): any =>
    async dispatch => {
      if (redux) {
        dispatch(getGroupsFilteredRequest());
      }
      try {
        const result: any = await axios(
          `${ENDPOINT_PRODUCT_CATEGORIES}/${idCategory}/product-groups${constructSearchObj(
            searchObj,
          )}`,
        );
        if (redux) {
          dispatch(
            getGroupsFilteredSuccess({
              data: result.data.products,
              idCategory: idCategory,
            }),
          );
        }
        return result;
      } catch (error) {
        if (redux) {
          dispatch(getGroupsFilteredRejected());
        }
        return error.response;
      }
    };

export const getMenuItemsToValidate = (categoryId, productGroupId, brand, countries, regions, menuItem) => async dispatch => {

  let findObj: any = {};

  if (brand) {
    findObj.brand = brand;
  }

  if (countries) {
    findObj.countries = countries;

  }

  if (regions) {
    findObj.regions = regions;
  }

  if(menuItem){
    findObj.menuItem = menuItem
  }

  dispatch(getMenuItemsToValidateRequest());
  try {
    const result: any = await axios(
      `${ENDPOINT_PRODUCT_CATEGORIES}/${categoryId}/product-groups/${productGroupId}/menu-items${constructSearchObj(
        {
          ...findObj,
          limit: 51,
        },
      )}`,
    );
    dispatch(getMenuItemsToValidateSuccess());
    return result.data;
  } catch (error) {
    dispatch(getMenuItemsToValidateRejected());
    return null;
  }
};

export const getMenuItemsToValidateByCountry = (categoryId, productGroupId, brand, country, region) => async dispatch => {
  dispatch(getMenuItemsToValidateRequest());
  try {
    const result: any = await axios(
      `${ENDPOINT_PRODUCT_CATEGORIES}/${categoryId}/product-groups/${productGroupId}/menu-items${constructSearchObj(
        {
          brand,
          region: `["${region}"]`,
          countries: `[${country}]`,
          limit: 51,
        },
      )}`,
    );
    dispatch(getMenuItemsToValidateSuccess());
    return result.data;
  } catch (error) {
    dispatch(getMenuItemsToValidateRejected());
    return null;
  }
};

export const getMenuItemsFiltered =
  (
    searchObj = {
      productGroupId: 0,
      categoryId: 0,
      page: 1,
      limit: 100,
      brand: '',
    },
    redux = true,
  ): any =>
    async dispatch => {
      if (redux) {
        dispatch(getMenuItemsFilteredRequest());
      }
      try {
        const result: any = await axios(
          `${ENDPOINT_PRODUCT_CATEGORIES}/${searchObj.categoryId
          }/product-groups/${searchObj.productGroupId
          }/menu-items${constructSearchObj(searchObj)}`,
        );
        if (redux) {
          dispatch(
            getMenuItemsFilteredSuccess({
              data: result.data.menus,
              page: searchObj.page,
              group: searchObj.productGroupId,
            }),
          );
        }
        return result;
      } catch (error) {
        if (redux) {
          dispatch(getMenuItemsFilteredRejected());
        }
        return error.response;
      }
    };

export const getMenuItem =
  (categoryId, productGroupId, menuItemId, brand): any =>
    async dispatch => {
      dispatch(getMenuItemRequest());
      try {
        const result: any = await axios(
          `${ENDPOINT_PRODUCT_CATEGORIES}/${categoryId}/product-groups/${productGroupId}/menu-items/${menuItemId}${constructSearchObj(
            {
              brand,
              limit: 100,
            },
          )}`,
        );
        dispatch(getMenuItemSuccess({ data: { ...result.data, categoryId } }));
        return result.data;
      } catch (error) {
        dispatch(getMenuItemRejected());
        return error.response;
      }
    };

export const getGroupsCatalog =
  (brand, productGroup = '', restaurantId = 0, location = {}): any =>
    async dispatch => {
      let endpoint;
      if (restaurantId) {
        endpoint = `${ENDPOINT_PRODUCT_CATEGORIES}/0/product-groups${constructSearchObj(
          {
            brand,
            productGroup,
            restaurantId,
            limit: 100,
          },
        )}`;
      } else if (!restaurantId) {
        endpoint = `${ENDPOINT_PRODUCT_CATEGORIES}/0/product-groups${constructSearchObj(
          {
            brand,
            productGroup,
            ...location,
            limit: 100,
          },
        )}`;
      } else if (!productGroup) {
        dispatch(
          getGroupsSuccess({
            data: [],
          }),
        );
        return;
      }

      dispatch(getGroupsRequest());
      try {
        const result: any = await axios(endpoint);
        dispatch(
          getGroupsSuccess({
            data: result.data.products,
          }),
        );
        return result;
      } catch (error) {
        dispatch(getGroupsRejected());
        return error.response;
      }
    };
export const getMenuItemsCatalog =
  (brand, name = '', restaurantId = 0, location = {}): any =>
    async dispatch => {
      const endpoint = `${ENDPOINT_PRODUCT_CATEGORIES}/0/product-groups/0/menu-items${constructSearchObj(
        {
          brand,
          name,
          ...(restaurantId ? { restaurantId } : {}),
          ...location,
        },
      )}`;
      dispatch(getMenuItemsCatalogRequest());
      try {
        const result: any = await axios(endpoint);
        dispatch(
          getMenuItemsCatalogSuccess({
            data: result.data.menus,
          }),
        );
        return result;
      } catch (error) {
        dispatch(getMenuItemsCatalogRejected());
        return error.response;
      }
    };

export const assignUnassignMenuItems =
  (objToAssignUnassign): any =>
    async dispatch => {
      return axiosAction.post(
        `${ENDPOINT_MENU_ITEMS}/restaurants`,
        PLATFORM_ASSIGN_UNASSIGN_MENU_ITEMS_TO_RESTAURANTS,
        dispatch,
        objToAssignUnassign,
      );
    };
